module.exports = __webpack_public_path__ + "img/list5.e547d8dd.png";